//WE.Flow.Html.Contracts.Manifests.ToolbarItemManifest

export class ToolbarItemManifest {
    tooltip: string = "";
    icon: string = "";
    name: string = "";
    position: string = "";
    namespace: string = "";
    viewModelId: string = "";
    order: number = 0;
    openInNewTab: boolean = false;
    contextIds: string[] = null;
}
